// src/core/services/notifications.service.ts
import api from "@/core/services/axios";
import { withQuery } from "@/core/utils/queryParams";
import type { PagedResponse } from "@/models";
import type { Notification, NotificationSearchCriteria } from "@/core/types"; // <-- adjust path if needed

export class NotificationsService {
  constructor(private readonly baseRoute = "/notifications") {}

  async fetchNotifications(
    criteria: NotificationSearchCriteria
  ): Promise<PagedResponse<Notification>> {
    const url = withQuery(this.baseRoute, criteria as any);
    const res = await api.get<PagedResponse<Notification>>(url);
    return res.data;
  }

  async fetchNotificationsExport(criteria: NotificationSearchCriteria): Promise<Notification[]> {
    const url = withQuery(`${this.baseRoute}/export`, criteria as any);
    const res = await api.get<Notification[]>(url);
    return res.data;
  }

  async fetchNotificationById(id: number): Promise<Notification> {
    const res = await api.get<Notification>(`${this.baseRoute}/${id}`);
    return res.data;
  }

  async addNotification(newNotification: Notification): Promise<Notification> {
    const res = await api.post<Notification>(this.baseRoute, newNotification);
    return res.data;
  }

  async updateNotification(updatedNotification: Notification): Promise<Notification> {
    const res = await api.put<Notification>(
      `${this.baseRoute}/${updatedNotification.id}`,
      updatedNotification
    );
    return res.data;
  }

  async deleteNotification(id: number): Promise<void> {
    await api.delete(`${this.baseRoute}/${id}`);
  }
}

export const notificationsService = new NotificationsService();
